import { SwapOutlined } from "@ant-design/icons";
import ExchangeTabs from "./ExchangeTabs";
import ExchangeTable from "./ExchangeTable";

export default function ExchangeOperationsCard({ tab, onTabChange, rows }) {
  return (
        <section className="pb-10">
      <div className="bg-white rounded-[20px] shadow-lg p-4 sm:p-6 lg:p-8">
        <div className="flex items-center gap-3 pb-4 lg:pb-6 border-b">
          <div className="w-9 h-9 lg:w-11 lg:h-11 rounded-full bg-blue-100 flex items-center justify-center text-[var(--blue-3)]">
            <SwapOutlined />
          </div>
          <h2 className="m-0 font-semibold text-[18px] lg:text-[22px] text-[#0B1B3A]">
            История обменов
          </h2>
        </div>

        <div className="pt-4 lg:pt-6">
          <ExchangeTabs tab={tab} onTabChange={onTabChange} />
          <ExchangeTable rows={rows} />
        </div>
      </div>
    </section>
  );
}